import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconOrders from 'components/icons/IconOrders';

const styles = () => ({
  root: {
    overflow: 'hidden',
  },
  grid: {
    height: 325,
  },
  iconOrders: {
    width: 90,
    height: 101,
  },
});

const OrdersTableEmpty = ({ classes }) => (
  <div className={classes.root}>
    <Grid
      className={classes.grid}
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <IconOrders className={classes.iconOrders} />
      </Grid>
      <Grid item>
        <Typography variant="subheading" color="secondary">
          Unfortunately, there are no such orders
        </Typography>
      </Grid>
    </Grid>
  </div>
);

OrdersTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    iconOrders: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrdersTableEmpty);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableEmpty.js